document.addEventListener('DOMContentLoaded', () => {
  const $video = document.querySelector('.c-hero__cover--video');
  if (!$video) {
    return;
  }
  $video.addEventListener('canplay', () => {
    $video.classList.add('is-ready');
  }, { once: true });
});
